var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgShareAudio = function SvgShareAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.317 3.07L5 6.666H2.5a.833.833 0 00-.833.833v5c0 .46.373.833.833.833H5l4.317 3.597a.417.417 0 00.683-.32V3.39a.417.417 0 00-.683-.32zM3.333 8.332h2.27l2.73-2.275v7.884l-2.73-2.275h-2.27V8.333zm8.334-1.666a3.333 3.333 0 010 6.666v-1.666a1.667 1.667 0 100-3.334V6.667zm0-3.334a6.667 6.667 0 010 13.334V15a5 5 0 000-10V3.333z",
    fill: "#fff"
  })));
};
export default SvgShareAudio;